<p-tabs [(value)]="activeTabIndex" autoselectFirstTab class="referrals-tabs">
  <p-tablist>
    <p-tab *accessView="['CaseManagementReferral.Read']" [value]="0">Referrals</p-tab>
    <p-tab *accessView="['CareCoordination.Read']" [value]="1">Case Status</p-tab>
  </p-tablist>
  <p-tabpanels class="!pl-0">
    <p-tabpanel *accessView="['CaseManagementReferral.Read']" [value]="0">
      <app-referrals-tab
        [memberId]="memberId"
        [tenantId]="tenantId"
        [memberPrepopulatedData]="memberPrepopulatedData"
      ></app-referrals-tab>    
    </p-tabpanel>
    <p-tabpanel *accessView="['CareCoordination.Read']" [value]="1">
      <app-case-status
        [memberId]="memberId"
        [tenantId]="tenantId"
      ></app-case-status>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
